if (customElements.get('quick-buy') === undefined) {
  customElements.define(
    'quick-buy',
    class QuickBuy extends HTMLElement {
      constructor() {
        'use strict';
        super();

        this.processingModal = false;
        this.button = this.querySelector('a[href*="modal"]');

        if (!this.button) {
          console.error('Quick buy button not found');
          return;
        }

        this.targetModalId = this.button.getAttribute('href').substring(1);
        this.quickBuyProductHandle = this.button.dataset.productHandle;

        // Extract product ID from modal ID (format: modal-{productId}-product)
        const modalIdMatch = this.targetModalId.match(/modal-(\d+)-product/);
        const productId = modalIdMatch ? modalIdMatch[1] : this.quickBuyProductHandle;

        // Set missing dataset properties
        this.dataset.product = productId;
        this.dataset.url =
          this.button.dataset.url || window.location.origin + '/products/' + this.quickBuyProductHandle;

        this.button.addEventListener('click', this.onModalRequestOpen.bind(this));
      }

      async onModalRequestOpen(event) {
        event.preventDefault();
        if (this.processingModal === true) {
          return;
        }

        const modal = document.getElementById(this.targetModalId);

        if (modal) {
          Woolman.ModalsAndDrawers.showModalOrDrawer(this.targetModalId);
          return;
        }

        this.processingModal = true;

        // Clean up any existing quick buy modals
        document.querySelectorAll('[data-quick-buy-modal]').forEach((modal) => {
          modal.remove();
        });

        try {
          const rootUrl = window.routes.root == '/' ? '/' : window.routes.root + '/'; // if user has selected locale convert root url from /en-gb to /en-gb/
          const res = await fetch(`${rootUrl}products/${this.quickBuyProductHandle}?view=ajax-modal`);

          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }

          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const modalElement = doc.body.firstChild;
          document.body.appendChild(modalElement);
          setTimeout(() => {
            Woolman.ModalsAndDrawers.showModalOrDrawer(this.targetModalId);
          }, 100);

          this.modal = modalElement;
          this.hookEvents();
        } catch (error) {
          console.error('Error loading quick buy modal:', error);
          this.processingModal = false;
        }
      }

      hookEvents() {
        this.updateOptions();

        const radiosElement = this.modal.querySelector('.product-modal__radios');
        if (radiosElement) {
          radiosElement.addEventListener('change', this.onVariantChange.bind(this));
        }

        const closeButton = this.modal.querySelector('[data-close]');
        if (closeButton) {
          closeButton.addEventListener('click', (e) => {
            Woolman.ModalsAndDrawers.closeModalOrDrawerOrDrawerFromEvent(e);
            setTimeout(() => this.cleanupModal(), 300);
          });
        }

        const overlay = this.modal.querySelector('[data-overlay]');
        if (overlay) {
          overlay.addEventListener('click', (e) => {
            Woolman.ModalsAndDrawers.closeModalOrDrawerOrDrawerFromEvent(e);
            setTimeout(() => this.cleanupModal(), 300);
          });
        }

        const productForm = document.getElementById(`product-form-${this.dataset.product}`);
        if (productForm) {
          productForm.addEventListener('submit', this.handleSubmit.bind(this));
        }

        // Initialize modal-radios web component
        this.initializeModalRadios();

        this.processingModal = false;
      }

      initializeModalRadios() {
        const modalRadiosElement = this.modal.querySelector('modal-radios');
        if (modalRadiosElement) {
          // Check if the element is already upgraded
          if (modalRadiosElement.constructor === HTMLElement) {
            // Force upgrade by cloning and replacing
            const upgradedElement = document.createElement('modal-radios');
            // Copy all attributes
            Array.from(modalRadiosElement.attributes).forEach((attr) => {
              upgradedElement.setAttribute(attr.name, attr.value);
            });
            // Copy all child nodes
            while (modalRadiosElement.firstChild) {
              upgradedElement.appendChild(modalRadiosElement.firstChild);
            }
            // Replace the element
            modalRadiosElement.parentNode.replaceChild(upgradedElement, modalRadiosElement);
          }
        }
      }

      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);

        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        } else {
          this.updateVariantInput();
          this.renderProductInfo();
        }
      }

      updateOptions() {
        const fieldsets = Array.from(this.modal.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.product}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          if (this.modal.dataset.isPreorder == 'true') {
            addButtonText.textContent = window.variantStrings.preOrder;
          } else {
            addButtonText.textContent = window.variantStrings.addToCart;
          }
        }

        if (!modifyClass) return;
      }

      renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&view=ajax-modal`)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const destination = document.getElementById(`price-${this.dataset.product}`);
            const source = html.getElementById(`price-${this.dataset.product}`);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(`price-${this.dataset.product}`);

            if (price) price.classList.remove('hidden');
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          })
          .catch((error) => {
            console.error('Error updating product info:', error);
          });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.product}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.product}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
      }

      getVariantData() {
        if (!this.variantData) {
          const jsonElement = this.modal.querySelector('[type="application/json"]');
          if (jsonElement) {
            this.variantData = JSON.parse(jsonElement.textContent);
          } else {
            console.error('Variant data JSON element not found');
            this.variantData = [];
          }
        }
        return this.variantData;
      }

      async handleSubmit() {
        const overlay = this.modal.querySelector('[data-overlay]');
        overlay.click();
        Woolman.ModalsAndDrawers.closeModalOrDrawer(this.targetModalId);

        // Clean up the modal after a short delay to allow the modal to close
        setTimeout(() => {
          this.cleanupModal();
        }, 300);
      }

      cleanupModal() {
        if (this.modal && this.modal.parentNode) {
          // Remove event listeners before removing the element
          const radiosElement = this.modal.querySelector('.product-modal__radios');
          if (radiosElement) {
            radiosElement.removeEventListener('change', this.onVariantChange.bind(this));
          }

          const closeButton = this.modal.querySelector('[data-close]');
          if (closeButton) {
            closeButton.removeEventListener('click', Woolman.ModalsAndDrawers.closeModalOrDrawerOrDrawerFromEvent);
          }

          const overlay = this.modal.querySelector('[data-overlay]');
          if (overlay) {
            overlay.removeEventListener('click', Woolman.ModalsAndDrawers.closeModalOrDrawerOrDrawerFromEvent);
          }

          const productForm = document.getElementById(`product-form-${this.dataset.product}`);
          if (productForm) {
            productForm.removeEventListener('submit', this.handleSubmit.bind(this));
          }

          this.modal.remove();
          this.modal = null;
        }
      }
    }
  );

  customElements.define(
    'modal-radios',
    class ModalRadios extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Ensure the element is properly initialized when connected to DOM
        if (!this.hasAttribute('data-initialized')) {
          this.setAttribute('data-initialized', 'true');
          this.addEventListener('change', this.onVariantChange.bind(this));
        }
      }

      onVariantChange(e) {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantStatuses();
      }

      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });

        this.updateLegends();
      }

      updateLegends() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        fieldsets.forEach((fieldset) => {
          const legend = fieldset.querySelector('legend [data-variant-legend]');
          const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
          legend.textContent = selectedOption.getAttribute('value');
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      getVariantData() {
        if (!this.variantData) {
          const jsonElement = this.querySelector('[type="application/json"]');
          if (jsonElement) {
            this.variantData = JSON.parse(jsonElement.textContent);
          } else {
            console.error('Variant data JSON element not found in ModalRadios');
            this.variantData = [];
          }
        }
        return this.variantData;
      }

      updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
          (variant) => this.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
          if (index === 0) return;
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
          const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
          listOfOptions.forEach((input) => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
              input.classList.remove('disabled');
            } else {
              input.classList.add('disabled');
            }
          });
        });
      }
    }
  );
}
